import * as regexPatterns from 'utils/regexPatterns';

export default function validateEmailList(value) {
	return value
		.split(',')
		.map(s => s.trim())
		.every(s => regexPatterns.email.test(s));
}
